<div class="flex flex-wrap items-center justify-end gap-x-4 gap-y-1">
  <div
    class="font-lato text-brand-muted flex flex-wrap items-center justify-end gap-1 text-xs leading-snug"
  >
    <span
      >Showing {{ itemCount }}
      {{ itemCount === 1 ? itemLabel.slice(0, -1) : itemLabel }}</span
    >
    <!-- Debug: parts.length = {{ parts.length }} -->
    @if (parts && parts.length > 0) {
      <span>•</span>
      @for (part of parts; track part; let last = $last) {
        <span>{{ part }}</span>
        @if (!last) {
          <span>•</span>
        }
      }
    }
  </div>
  @if (hasFilters) {
    <button
      type="button"
      (click)="onClearAll()"
      class="font-lato inline-flex shrink-0 cursor-pointer items-center gap-0.5 text-xs font-semibold text-blue-600 hover:underline focus:outline-none"
      aria-label="Clear all filters"
    >
      Clear all
      <mat-icon
        class="flex! h-3.5! w-3.5! items-center! justify-center! text-sm!"
        aria-hidden="true"
      >
        close
      </mat-icon>
    </button>
  }
</div>

